import { LockClosedIcon } from '@heroicons/react/solid'
import { c, FC } from 'lib/component-utils'
import { ChangeEvent, forwardRef } from 'react'

type Props = {
  checked: boolean
  indeterminate?: boolean
  locked?: boolean
  onChange: (value: ChangeEvent<HTMLInputElement>) => void
}

const Checkbox: FC<Props, 'input'> = (
  { checked, indeterminate, locked, onChange, className, disabled, ...rest },
  ref
) => {
  if (locked) {
    return <LockClosedIcon className="w-4 h-4 text-primary-600" />
  }

  const hoverClassName = disabled
    ? 'hover:border-gray-300'
    : checked || indeterminate
      ? 'hover:border-primary-400 group-hover/checkbox:border-primary-400'
      : 'hover:border-gray-400 group-hover/checkbox:border-gray-400'

  return (
    <input
      ref={(input: HTMLInputElement) => {
        if (input) {
          input.indeterminate = Boolean(indeterminate)
        }
        if (typeof ref === 'function') {
          ref(input)
        } else if (ref) {
          ref.current = input
        }
      }}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event)}
      className={c`w-4 h-4 rounded border-gray-300 bg-white cursor-pointer text-primary-600 focus:ring-primary-500 dark:focus:ring-offset-white ${hoverClassName} ${className}`}
      {...rest}
    />
  )
}

export default forwardRef(Checkbox as any) as typeof Checkbox
